const useLoader = () => {}

export default useLoader